// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Code permettant d'Agrandir la carte au survol avec un effet non sacadé */
.program-card:hover {
  transform: scale(1.05);
  cursor: pointer;
}

.program-card {
  transition: transform 0.3s ease-in-out;
}

.program-card-img {
  height: 200px;
  object-fit: cover;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/Components/ProgramItem/ProgramItem.css"],"names":[],"mappings":"AAAA,2EAA2E;AAC3E;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,WAAW;AACb","sourcesContent":["/* Code permettant d'Agrandir la carte au survol avec un effet non sacadé */\n.program-card:hover {\n  transform: scale(1.05);\n  cursor: pointer;\n}\n\n.program-card {\n  transition: transform 0.3s ease-in-out;\n}\n\n.program-card-img {\n  height: 200px;\n  object-fit: cover;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
